










































import { isEmpty } from 'lodash'
import { computed, defineComponent, ref } from '@vue/composition-api'

import Resume from '@/components/Resume.vue'
import SkeletonLoader from '@/components/SkeletonLoader.vue'
import store from '@/store'
import { ResumeGetters } from '@/store/modules/resume/getters'
import { JobItemInterface } from '@/store/modules/resume/types'
import { TechnicalExperienceGetters } from '@/store/modules/technical-experience/getters'
import { TechnicalExperienceInterface } from '@/store/modules/technical-experience/types'
import { TechnicalSkillGetters } from '@/store/modules/technical-skills/getters'
import { TechnicalSkillInterface } from '@/store/modules/technical-skills/types'

export default defineComponent({
  name: 'AboutMe',
  components: {
    Resume,
    SkeletonLoader
  },
  setup() {
    const alignments = [ 'start', 'center', 'end' ]
    const isLoading = ref<boolean>(true)
    const resumeData = computed<Array<JobItemInterface>>(() => store.getters[ResumeGetters.All])
    const experienceData = computed<Array<TechnicalExperienceInterface>>(() => store.getters[TechnicalExperienceGetters.All])
    const skills = computed<Array<TechnicalSkillInterface>>(() => store.getters[TechnicalSkillGetters.All])

    async function loadingCheck() {
      while(isEmpty(resumeData) || isEmpty(experienceData) || isEmpty(skills))
        isLoading.value = true
      
      // let the people see the pretty lil skeleton loader
      setTimeout(() =>
        isLoading.value = false, 2000)
    }

    console.info('+1 wisdom for inspecting the console')

    loadingCheck()

    return {
      alignments,
      isLoading
    }
  },
  data: () => ({
    profilePic: require('@/assets/pfp.png')
  })
})
